module.exports = __webpack_public_path__ + "img/magento-custom-development_small@2x.7794dd93.jpg";